// extracted by css-extract-rspack-plugin
module.exports =  {"root":"f8f1cccc03"};